import { combineReducers, CombinedState } from 'redux';

import {
  actorBookReducer as actorBookState,
  parameterDefaultState,
  settingsReducer as settingsState,
  settingsDefaultState,
  userReducer as userState,
  userDefaultState,
  userListReducer as userListState,
  userListDefaultState,
  mapReducer as mapState,
  mapDefaultState,
  socketReducer as socketState,
  socketDefaultState,
  pageReducer as pageState,
  pageDefaultState,
  ontologyReducer as ontologyState,
  ontologyDefaultState,
  userRightsReducer as userRightsState,
  userRightsDefaultState,
  eventReducer as eventState,
  eventDefaultState,
  incidentFolderReducer as incidentFolderState,
  incidentFolderDefaultState,
  workPackageReducer as workPackageState,
  workPackageDefaultState,
  incidentReducer as incidentState,
  incidentDefaultState,
  taskReducer as taskState,
  taskDefaultState,
  outcomeReducer as outcomeState,
  outcomeDefaultState,
  deliverableReducer as deliverableState,
  deliverableDefaultState,
  trainingObjectiveReducer as trainingObjectiveState,
  trainingObjectiveDefaultState,
  injectionReducer as injectionState,
  injectionDefaultState,
  projectInputReducer as projectInputState,
  projectInputDefaultState,
  actionReducer as actionState,
  actionDefaultState,
  kanbanReducer as kanbanState,
  kanbanDefaultState,
  observationTaskReducer as observationTaskState,
  observationTaskDefaultState,
  testReducer as testState,
  testDefaultState,
  configurationChangeRequestReducer as configurationChangeRequestState,
  configurationChangeRequestDefaultState,
  troubleTicketReducer as troubleTicketState,
  troubleTicketDefaultState,
  registryReducer as registryState,
  registryDefaultState,
  settingReducer as settingState,
  settingDefaultState,
  technicalSupportRequestReducer as technicalSupportRequestState,
  technicalSupportRequestDefaultState,
  experimentationReducer as experimentationState,
  experimentationDefaultState,
  resourceReducer as resourceState,
  resourceDefaultState,
  stateReducer as stateFlowState,
  stateDefaultState,
  transactionReducer as transactionState,
  transactionDefaultState,
  permissionReducer as permissionState,
  permissionDefaultState,
  userRolePermissionReducer as userRolePermissionState,
  userRolePermissionsDefaultState,
  unitsReducer as unitsState,
  unitsDefaultState,
  contentReducer as contentState,
  contentDefaulState,
  fieldsReducer as fieldsState,
  fieldsDefaultState,
  lillReducer as lillState,
  lillDefaultState,
  roadToCurrentSettingsReducer as roadToCurrentSettingsState,
  roadToCurrentSettingsDefaultState,
  battleRhythmReducer as battleRhythmState,
  battleRhythmDefaultState,
  odTaskReducer as odTaskState,
  odTaskDefaultState,
  effectDefaultState,
  effectReducer as effectState,
  decisiveConditionDefaultState,
  decisiveConditionReducer as decisiveConditionState,
  lineOfEffortReducer as lineOfEffortState,
  lineOfEffortDefaultState,
  planOrderReportProcessReducer as planOrderReportProcessState,
  planOrderReportProcessDefaultState,
  turnChartReducer as turnChartState,
  turnChartDefaultState,
  phaseReducer as phaseState,
  phaseDefaultState,
  projectsReducer as projectsState,
  projectsDefaultState,
  coaReducer as coaState,
  coaDefaultState,
  riskReducer as riskState,
  riskDefaultState,
} from 'src/app/redux/reducers';

import { ROOT_RESET_REDUCER_STATE_TO_DEFAULT } from 'src/app/redux/redux-types';
import { reduxRootTypes } from 'src/types';

const appReducer = combineReducers({
  settingsState,
  userState,
  userListState,
  mapState,
  socketState,
  pageState,
  ontologyState,
  userRightsState,
  eventState,
  incidentFolderState,
  workPackageState,
  incidentState,
  taskState,
  outcomeState,
  deliverableState,
  trainingObjectiveState,
  injectionState,
  projectInputState,
  actionState,
  kanbanState,
  observationTaskState,
  testState,
  configurationChangeRequestState,
  troubleTicketState,
  registryState,
  settingState,
  technicalSupportRequestState,
  experimentationState,
  stateFlowState,
  resourceState,
  transactionState,
  permissionState,
  userRolePermissionState,
  unitsState,
  contentState,
  fieldsState,
  lillState,
  roadToCurrentSettingsState,
  actorBookState,
  battleRhythmState,
  odTaskState,
  decisiveConditionState,
  effectState,
  lineOfEffortState,
  planOrderReportProcessState,
  turnChartState,
  phaseState,
  projectsState,
  coaState,
  riskState,
});

const defaultState: CombinedState<reduxRootTypes.RootStateType> = {
  mapState: { ...mapDefaultState },
  settingsState: { ...settingsDefaultState },
  userState: { ...userDefaultState },
  userListState: { ...userListDefaultState },
  socketState: { ...socketDefaultState },
  pageState: { ...pageDefaultState },
  ontologyState: { ...ontologyDefaultState },
  userRightsState: { ...userRightsDefaultState },
  eventState: { ...eventDefaultState },
  incidentFolderState: { ...incidentFolderDefaultState },
  workPackageState: { ...workPackageDefaultState },
  incidentState: { ...incidentDefaultState },
  taskState: { ...taskDefaultState },
  outcomeState: { ...outcomeDefaultState },
  deliverableState: { ...deliverableDefaultState },
  trainingObjectiveState: { ...trainingObjectiveDefaultState },
  injectionState: { ...injectionDefaultState },
  projectInputState: { ...projectInputDefaultState },
  actionState: { ...actionDefaultState },
  kanbanState: { ...kanbanDefaultState },
  observationTaskState: { ...observationTaskDefaultState },
  testState: { ...testDefaultState },
  configurationChangeRequestState: { ...configurationChangeRequestDefaultState },
  troubleTicketState: { ...troubleTicketDefaultState },
  registryState: { ...registryDefaultState },
  settingState: { ...settingDefaultState },
  technicalSupportRequestState: { ...technicalSupportRequestDefaultState },
  experimentationState: { ...experimentationDefaultState },
  stateFlowState: { ...stateDefaultState },
  resourceState: { ...resourceDefaultState },
  transactionState: { ...transactionDefaultState },
  permissionState: { ...permissionDefaultState },
  userRolePermissionState: { ...userRolePermissionsDefaultState },
  contentState: { ...contentDefaulState },
  unitsState: { ...unitsDefaultState },
  fieldsState: { ...fieldsDefaultState },
  lillState: { ...lillDefaultState },
  actorBookState: { ...parameterDefaultState },
  roadToCurrentSettingsState: { ...roadToCurrentSettingsDefaultState },
  battleRhythmState: { ...battleRhythmDefaultState },
  decisiveConditionState: { ...decisiveConditionDefaultState },
  effectState: { ...effectDefaultState },
  odTaskState: { ...odTaskDefaultState },
  lineOfEffortState: { ...lineOfEffortDefaultState },
  planOrderReportProcessState: { ...planOrderReportProcessDefaultState },
  turnChartState: { ...turnChartDefaultState },
  phaseState: { ...phaseDefaultState },
  projectsState: { ...projectsDefaultState },
  coaState: { ...coaDefaultState },
  riskState: { ...riskDefaultState },
};

export const rootReducer = (
  state: CombinedState<reduxRootTypes.RootStateType> | undefined,
  action: reduxRootTypes.ActionType,
) => {
  if (action.type === ROOT_RESET_REDUCER_STATE_TO_DEFAULT) {
    return appReducer(defaultState, action as any);
  }

  return appReducer(state, action);
};
